"use strict";
/**
 * Contentful general helper functions
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Recursively reformat response to convert collections
 * objects with `items` into arrays with items
 *
 * @param {object} response
 * @return {object}
 */
const flattenItems = (response) => {
    if (response === null) {
        return response;
    }
    const keys = Object.keys(response);
    keys.forEach((key) => {
        if (response[key] && Array.isArray(response[key].items)) {
            response[key] = response[key].items;
            response[key].forEach((item) => {
                flattenItems(item);
            });
        }
    });
    return response;
};
exports.default = flattenItems;
//# sourceMappingURL=flattenContentfulItems.js.map